import { format, isAfter, parseISO } from 'date-fns'
import React, { FunctionComponent, useCallback } from 'react'
import useDictionary from '../../../hooks/use-dictionary/useDictionary'
import TextWithImage from '../text-with-image/TextWithImage'

export interface Talk {
  body: string
  date: string // ISO 8601
  image: string
  title: string
  url: string
}

export interface TalksProps {
  className?: string
  talks: Talk[]
}

const Talks: FunctionComponent<TalksProps> = ({ talks, className }) => {
  const dictionary = useDictionary()

  /**
   * Get link text based on date
   */
  const getLinkText = useCallback(
    (date: Date) =>
      isAfter(date, new Date())
        ? `${dictionary.get('availableToWatchFrom')} ${format(
            date,
            'EEEE dd MMMM',
          )}`
        : dictionary.get('watchEvent'),
    [],
  )

  /**
   * Get size text based on date
   */
  const getSize = useCallback(
    (date: Date) => (isAfter(date, new Date()) ? 'medium' : 'small'),
    [],
  )

  const getImageAlignment = useCallback((index: number, date: Date):
    | 'left'
    | 'right' => {
    if (!isAfter(date, new Date())) {
      return 'left'
    }
    return index % 2 === 0 ? 'left' : 'right'
  }, [])

  return (
    <div className={className}>
      {talks.map(({ title, image, body, url, date }, index) => (
        <TextWithImage
          date={parseISO(date)}
          image={image}
          imageAlignment={getImageAlignment(index, parseISO(date))}
          key={`talk-${index}`}
          link={{
            linkText: getLinkText(parseISO(date)),
            url,
          }}
          size={getSize(parseISO(date))}
          text={[body]}
          title={title}
        />
      ))}
    </div>
  )
}

export default Talks
